<script>
  import { nrkLogoNrk } from '@nrk/core-icons/logo'
</script>

<a href="https://nrk.no" aria-label="Nrk forsiden" class="logo">
  <span aria-hidden="true">
    {@html nrkLogoNrk}
  </span>
</a>

<style>
  .logo {
    position: absolute;
    top: 25px;
    left: 25px;
    font-size: 1.5rem;
    z-index: 1;
    background: transparent;
    color: #fff;
  }
</style>
